module.exports = __webpack_public_path__ + "static/media/SarahSwitek_08_EnergyLevel-Confirmation_1.0543e156.mp3";